import React from 'react';
import Info from './info-view/info.jsx';
import Image from './info-view/image.jsx';
import SharedStorage from './info-view/shared-storage.jsx'
import FindMessage from './info-view/find-message.jsx';
import QRCodeInvite from './info-view/qr-code-invite.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import Members from './info-view/members.jsx';
import Background from './info-view/background.jsx';
import { makeImageUrl } from '../lib/blob-helpers.js';

export const SCREEN = {
  INFO: 0,// màn hình thông tin
  IMAGE: 1,// màn hình danh sách ảnh
  BACKGROUND: 2,// màn hình danh sách background
  MEMBERS: 3, //màn hình danh sách thành viên,
  FIND_MESSAGE: 4,
  QR_INVITE_GROUP: 5, // màn hình QR Code mời tham gia nhóm
}

class InfoViewContent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.getBlankState();
    this.renderScreen = this.renderScreen.bind(this);
    this.handleSetScreen = this.handleSetScreen.bind(this);
  }

  getBlankState() {
    return {
      screen: SCREEN.INFO
    }
  }

  renderScreen() {
    let element = undefined;
    const { screen } = this.state
    const { formatMessage } = this.props.intl;

    switch (screen) {
      case SCREEN.IMAGE:
        element = <SharedStorage
          title={<FormattedMessage id="info_image" defaultMessage="Media, links, files" description="Media, links, files" />}
          handleSetScreen={this.handleSetScreen}
          topic={this.props.topic}
          tinode={this.props.tinode}
        />;
        break;
      case SCREEN.BACKGROUND:
        element = <Background
          tinode={this.props.tinode}
          handleSetScreen={this.handleSetScreen}
          topic={this.props.topic}
        />;
        break;
      case SCREEN.MEMBERS:
        element = <Members
          title={<FormattedMessage id="info_members_list" defaultMessage="Members list" />}
          handleSetScreen={this.handleSetScreen}
          groupMembers={this.props.groupMembers}
          tinode={this.props.tinode}
          topic={this.props.topic}
          onTopicSelected={this.props.onTopicSelected}
          onShowDialog={this.props.onShowDialog}
          onShowAlert={this.props.onShowAlert}
          admin={this.props.admin}
        />;
        break;
      case SCREEN.FIND_MESSAGE:
        element = <FindMessage
          placeholder={formatMessage({
            id: "sidepanel_search",
            defaultMessage: "Search"
          })}
          handleSetScreen={this.handleSetScreen}
          topic={this.props.topic}
          tinode={this.props.tinode}
          onCancel={this.props.onCancel}
          onShowDialog={this.props.onShowDialog}
        />;
        break;
      case SCREEN.QR_INVITE_GROUP:
        element = <QRCodeInvite
          handleSetScreen={this.handleSetScreen}
          topic={this.props.topic}
          tinode={this.props.tinode}
          onCancel={this.props.onCancel}
          onShowDialog={this.props.onShowDialog}
        />;
        break;
      default:
        const topicInfo = this.props.tinode.getTopicByName(this.props.topic);
        const topicAvatar = makeImageUrl(topicInfo.public ? topicInfo.public.photo : null)
        const isBlockUser = topicInfo.isBlockUser ? topicInfo.isBlockUser : false
        let sumContent = (topicInfo.shareImage ? topicInfo.shareImage.length : 0) + (topicInfo.shareLink ? topicInfo.shareLink.length : 0) + (topicInfo.shareFile ? topicInfo.shareFile.length : 0)

        element = <Info
          handleSetScreen={this.handleSetScreen}
          tinode={this.props.tinode}
          topic={this.props.topic}
          topicAvatar={this.props.avatarTopic ? this.props.avatarTopic : null}
          handleShowGroupMembers={this.props.handleShowGroupMembers}
          groupMembers={this.props.groupMembers}
          leaveGroup={this.props.leaveGroup}
          setGroupPrivate={this.props.setGroupPrivate}
          dissolveGroup={this.props.dissolveGroup}
          onShowAlert={this.props.onShowAlert}
          onError={this.props.onError}
          isBlockUser={isBlockUser}
          sharedImagePhotos={topicInfo.shareImage ? topicInfo.shareImage : []}
          sumContent={sumContent}
        />;
        break;
    }
    return element;
  }

  handleSetScreen(screen) {
    this.setState({ screen });
  }

  render() {
    return (
      <div id="info-view-content">
        {this.renderScreen()}
      </div>
    )
  }
}

export default injectIntl(InfoViewContent);
